import React from 'react';
import { SafeComponent } from '@fiverr-private/orca';
import { IconButton } from '@fiverr-private/button';
import { PlaySolidIcon, PauseSolidIcon } from '@fiverr-private/visuals';
import { sendBigQueryEvent, sendMixPanelEvent } from '../../utils/biEvents';
import { MP_VIDEO_CONTROLS_CLICKED } from '../../utils/biEvents/events/mixPanelEvents';
import { BQ_VIDEO_PAUSE, BQ_VIDEO_PLAY } from '../../utils/biEvents/events/bigQueryEvents';

interface VideoControlButtonProps {
  videoRef: React.RefObject<HTMLVideoElement>;
  isPlaying?: boolean;
  onToggle?: () => void;
}

const VideoControlButton = ({ videoRef, isPlaying = false, onToggle }: VideoControlButtonProps) => {
  const sendVideoControlMixpanelEvent = (action: 'Pause' | 'Play') =>
    sendMixPanelEvent({
      eventName: MP_VIDEO_CONTROLS_CLICKED,
      params: {
        action,
      },
    });

  const handleClick = () => {
    if (onToggle) {
      onToggle();
    } else {
      // Fallback to original behavior if no external handler provided
      if (!videoRef.current) {
        return;
      }

      if (isPlaying) {
        videoRef.current.pause();
        sendBigQueryEvent({ eventName: BQ_VIDEO_PAUSE });
      } else {
        videoRef.current.play();
        sendBigQueryEvent({ eventName: BQ_VIDEO_PLAY });
      }

      sendVideoControlMixpanelEvent(isPlaying ? 'Pause' : 'Play');
    }
  };

  return (
    <IconButton onClick={handleClick} intent="primary" aria-label="Start/Pause video" shape="circle">
      {isPlaying ? <PauseSolidIcon color="white" /> : <PlaySolidIcon color="white" />}
    </IconButton>
  );
};

export default SafeComponent(VideoControlButton);
